import CuttingName from "./CuttingName";
import CuttingLink from "./CuttingLink";

import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";

import ProviderName from "../../../../timber/components/provider/ProviderDetail/ProviderName";
import ProviderLink from "../../../../timber/components/provider/ProviderDetail/ProviderLink";

import ContractorName from "../../../../timber/components/contractor/ContractorDetail/ContractorName";
import ContractorLink from "../../../../timber/components/contractor/ContractorDetail/ContractorLink";

import ForestOwnerName from "../../../../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerName";
import ForestOwnerLink from "../../../../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CuttingDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Cutting-detail-title"
                    >
                        { label || t`Cutting` }: <CuttingName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Cutting-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Cutting-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="name-label" sx={{ textAlign: "left" }}><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="name-value" sx={{ textAlign: "left" }}>{ data.name || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="state-label" sx={{ textAlign: "left" }}><Trans>State</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="state-value" sx={{ textAlign: "left" }}>{ toStringCuttingState(data.state) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="startAt-label" sx={{ textAlign: "left" }}><Trans>Start At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="startAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.startAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="endAt-label" sx={{ textAlign: "left" }}><Trans>End At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="endAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.endAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="workOrder-label" sx={{ textAlign: "left" }}><Trans>Work Order</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="workOrder-value" sx={{ textAlign: "left" }}>{ data.workOrder || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="locationId-label" sx={{ textAlign: "left" }}><Trans>Location</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="locationId-value" sx={{ textAlign: "left" }}>{ data.locationId ? (<LocationLink id={ data.locationId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="providerId-label" sx={{ textAlign: "left" }}><Trans>Provider</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="providerId-value" sx={{ textAlign: "left" }}>{ data.providerId ? (<ProviderLink id={ data.providerId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="contractorId-label" sx={{ textAlign: "left" }}><Trans>Contractor</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="contractorId-value" sx={{ textAlign: "left" }}>{ data.contractorId ? (<ContractorLink id={ data.contractorId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="forestOwnerId-label" sx={{ textAlign: "left" }}><Trans>Forest Owner</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="forestOwnerId-value" sx={{ textAlign: "left" }}>{ data.forestOwnerId ? (<ForestOwnerLink id={ data.forestOwnerId }/>) : '-' }</Grid>

                    <Grid size={ {xs: 4} } data-testid="allowsMultiStorageShipments-label" sx={{ textAlign: "left" }}><Trans>Allows Multi Storage Shipments</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="allowsMultiStorageShipments-value" sx={{ textAlign: "left" }}>{ data.allowsMultiStorageShipments ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>

            </Grid>
        </Stack>
    )
}

export default CuttingDetail;
